import { DiscoText } from "@disco-ui"
import PageContent from "../../../../main/page/content/PageContent"
import classes from "./ControlNotFoundPageContent.module.css"

function ControlNotFoundPageContent() {
  return (
    <PageContent customClassName={classes.container}>
      <DiscoText
        data-testid={"NotFoundPage.title"}
        marginBottom={3}
        variant={"heading-xxl"}
      >
        {"Oops!"}
      </DiscoText>
      <DiscoText
        data-testid={"NotFoundPage.description"}
        variant={"heading-md"}
        marginBottom={4}
        className={classes.description}
        color={"groovy.grey.500"}
      >
        {"Cannot find the page you want."}
      </DiscoText>
    </PageContent>
  )
}

export default ControlNotFoundPageContent
